import { LOAD_HEIRS } from 'store/types/heirActionTypes';
import helper from 'store/actions/actionHelper';

export const loadHeirs = (heirs: ContactDTO[]) =>
  helper.getAction(LOAD_HEIRS, { heirs });
